module.exports = __webpack_public_path__ + "media/images/home/sauna-2e3cb4c3e5f7e4ec3b4feffa14167c01.jpg";